import { register } from "./registry";

/**
 * A box shown only for some values of another field, e.g. the delivery's Cash/Bank and MR boxes only for pay modes that
 * collect money (T-D7). Hidden boxes are skipped by Enter (keyboard.ts skips anything inside [hidden]).
 *
 *   <label data-kit-show-when="Form.PayMode=Cash,Fonepay">Cash/Bank <select …></label>
 */
function sync(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>("[data-kit-show-when]").forEach((el) => {
    const [name, values] = (el.dataset.kitShowWhen ?? "").split("=");
    const field = el.closest("form")?.querySelector<HTMLInputElement | HTMLSelectElement>(`[name='${name}']`);
    if (field) el.hidden = !(values ?? "").split(",").includes(field.value);
  });
}

register(sync);
document.addEventListener("change", (e) => {
  const form = (e.target as Element | null)?.closest?.("form");
  if (form) sync(form);
});
